import { Button } from "@design-system/components/Button";
import { cn } from "@design-system/utils";
import { getCurrentLocaleCode } from "@mongez/localization";
import { Link, LinkProps } from "@remix-run/react";
import { isLocalizationEnabled } from "../../../../framework/remix/config/drivers";

export function PrimaryLink({ to, children, ...props }: LinkProps) {
  if (isLocalizationEnabled) {
    const localeCode = getCurrentLocaleCode();
    to = `/${localeCode}${to}`;
  }

  return (
    <Link to={to} {...props}>
      <Button>{children}</Button>
    </Link>
  );
}

export function BaseLink({ to, children, ...props }: LinkProps) {
  if (isLocalizationEnabled) {
    const localeCode = getCurrentLocaleCode();
    to = `/${localeCode}${to}`;
  }

  return (
    <Link
      to={to}
      {...props}
      className={cn(
        "text-gray-600 hover:underline dark:text-gray-400",
        props.className,
      )}
    >
      {children}
    </Link>
  );
}
